import ArrangeButton from 'components/Buttons/ArrangeButton';
import styled from 'styled-components';

const ResponsiveArrangeButton = styled(ArrangeButton)`
    @media (max-width: 768px) {
        display: none;
    }
`;

export default ResponsiveArrangeButton;